// ../../node_modules/mitt/dist/mitt.mjs
function mitt_default(n) {
  return { all: n = n || /* @__PURE__ */ new Map(), on: function(t, e) {
    var i = n.get(t);
    i ? i.push(e) : n.set(t, [e]);
  }, off: function(t, e) {
    var i = n.get(t);
    i && (e ? i.splice(i.indexOf(e) >>> 0, 1) : n.set(t, []));
  }, emit: function(t, e) {
    var i = n.get(t);
    i && i.slice().map(function(n2) {
      n2(e);
    }), (i = n.get("*")) && i.slice().map(function(n2) {
      n2(t, e);
    });
  } };
}

// ../base/src/emitter/index.ts
import Unit from "./unit.js";
var Emitter = class {
  emitter = mitt_default();
  state = {
    status: "in-detecting",
    accounts: void 0,
    chainId: void 0,
    balance: void 0
  };
  trackBalanceInterval;
  detectTimer;
  trackBalanceChangeOnceCallback = [];
  RPCMethod;
  provider;
  resolveDetect;
  detectPromise = new Promise(
    (resolve) => this.resolveDetect = () => {
      if (this.detectTimer) {
        clearTimeout(this.detectTimer);
      }
      resolve();
    }
  );
  constructor(RPCMethod) {
    this.RPCMethod = RPCMethod;
    this.RPCMethod.detectAndSetProvider().then(this.setProvider).catch((e) => {
      this.handleStatusChanged("not-installed");
      this.resolveDetect();
      if (typeof e === "string" && e.startsWith("Unable to detect window.")) {
        this.RPCMethod.subProvider().then(this.setProvider);
      }
    });
    this.detectTimer = setTimeout(() => {
      console.error(`detect ${this.RPCMethod.sessionKey ? "window." + this.RPCMethod.sessionKey.split("-")[0] : "wallet"} timeout.`);
      if (this.RPCMethod.sessionKey) {
        const times = Number(sessionStorage.getItem(this.RPCMethod.sessionKey) || 0);
        if (times >= this.RPCMethod.retryLimit) {
          this.handleStatusChanged("not-active");
          this.resolveDetect();
          throw new Error(`detect ${this.RPCMethod.sessionKey ? "window." + this.RPCMethod.sessionKey.split("-")[0] : "wallet"} timeout.`);
        }
        sessionStorage.setItem(this.RPCMethod.sessionKey, String(times + 1));
      }
      window.location.reload();
    }, this.RPCMethod.detectTimeout);
  }
  setProvider = (provider) => {
    this.batchGetInfo();
    this.RPCMethod.onChainIdChange(() => this.batchGetInfo());
    this.RPCMethod.onAccountsChange(() => this.batchGetInfo());
    this.provider = provider;
  };
  handleStateChange = (stateKey, newVal) => {
    const preVal = this.state[stateKey];
    let isValChanged = false;
    switch (stateKey) {
      case "accounts":
        isValChanged = preVal?.[0] !== newVal?.[0];
        break;
      case "balance":
        if (newVal !== void 0 && preVal !== void 0) {
          isValChanged = !preVal.equalsWith(newVal);
        } else {
          isValChanged = preVal !== newVal;
        }
        break;
      default:
        isValChanged = preVal !== newVal;
    }
    if (isValChanged) {
      Object.assign(this.state, { [stateKey]: newVal });
      this.emitter.emit(stateKey, newVal);
      if (stateKey === "balance" && this.trackBalanceChangeOnceCallback.length) {
        this.trackBalanceChangeOnceCallback.forEach((callback) => callback());
        this.trackBalanceChangeOnceCallback = [];
      }
    }
  };
  handleStatusChanged = (status) => this.handleStateChange("status", status);
  handleAccountsChanged = (accounts) => {
    const hasAccount = !!accounts?.[0];
    if (hasAccount) {
      this.handleStatusChanged("active");
    } else {
      this.handleStatusChanged("not-active");
    }
    this.handleStateChange("accounts", accounts);
  };
  handleChainChanged = (chainId) => {
    if (!chainId || chainId === "0xNaN") {
      this.handleStateChange("chainId", void 0);
      this.handleAccountsChanged(void 0);
      return;
    }
    this.handleStateChange("chainId", String(parseInt(chainId)));
  };
  handleBalanceChanged = (balanceMinUnit) => {
    if (typeof balanceMinUnit !== "string" && typeof balanceMinUnit !== "number") {
      this.handleStateChange("balance", void 0);
      return;
    }
    this.handleStateChange("balance", Unit.fromMinUnit(balanceMinUnit));
  };
  batchGetInfo = async ({ isRequestConnect } = { isRequestConnect: false }) => {
    try {
      const [chainId, accounts] = await Promise.all([
        this.RPCMethod.getChainId(),
        isRequestConnect ? this.RPCMethod.requestAccounts() : this.RPCMethod.getAccounts()
      ]);
      this.RPCMethod.setAccounts(accounts);
      let balanceTimeout = setTimeout(() => {
        this.handleChainChanged(chainId);
        this.handleAccountsChanged(accounts);
        this.handleBalanceChanged(void 0);
        this.resolveDetect();
        balanceTimeout = void 0;
      }, 1250);
      try {
        const balance = await this.RPCMethod.getBalance();
        if (balanceTimeout !== void 0) {
          clearTimeout(balanceTimeout);
          this.handleChainChanged(chainId);
          this.handleAccountsChanged(accounts);
        }
        this.handleBalanceChanged(balance);
      } catch (_) {
        if (balanceTimeout !== void 0) {
          clearTimeout(balanceTimeout);
          this.handleChainChanged(chainId);
          this.handleAccountsChanged(accounts);
          this.handleBalanceChanged(void 0);
        }
      }
      return accounts;
    } catch (err) {
      throw err;
    } finally {
      this.resolveDetect();
    }
  };
  checkConnected = (operate) => {
    const account = this.state.accounts?.[0];
    if (!account) {
      throw new Error(`${operate} error: request connect to wallet.`);
    }
    return account;
  };
  on = this.emitter.on;
  off = this.emitter.off;
  clear = this.emitter.all.clear;
  completeDetect = () => this.detectPromise;
  startTrackBalance = (interval = 1500) => {
    this.stopTrackBalance();
    const getAndSetBalance = () => {
      const account = this.state.accounts?.[0];
      const chainId = this.state.chainId;
      if (!chainId || chainId === "9007199254740991" || !account) {
        return;
      }
      this.RPCMethod.getBalance().then((balance) => this.handleBalanceChanged(balance));
    };
    getAndSetBalance();
    this.trackBalanceInterval = setInterval(getAndSetBalance, interval);
  };
  stopTrackBalance = () => {
    if (this.trackBalanceInterval !== void 0) {
      clearInterval(this.trackBalanceInterval);
      this.trackBalanceInterval = void 0;
    }
  };
  trackBalanceChangeOnce = (callback) => {
    if (typeof callback !== "function")
      return;
    this.trackBalanceChangeOnceCallback.push(callback);
  };
  connect = async () => {
    const currentStatus = this.state.status;
    if (currentStatus !== "not-active") {
      if (currentStatus === "active")
        return Promise.resolve(this.state.accounts);
      else
        throw new Error(`Current status ${currentStatus} is not allowed to connect.`);
    }
    this.handleStatusChanged("in-activating");
    const res = this.batchGetInfo({ isRequestConnect: true });
    res.catch(() => this.handleStatusChanged("not-active"));
    return res;
  };
  sendTransaction = (params) => {
    if (!this.RPCMethod.sendTransaction) {
      throw new Error(`Current Wallet does'nt have sendTransaction method.`);
    }
    const account = this.checkConnected("sendTransaction");
    return this.RPCMethod.sendTransaction({
      ...params,
      from: account,
      ...params.value ? {} : { value: "0x0" }
    });
  };
  personalSign = (message) => {
    if (!this.RPCMethod.personalSign) {
      throw new Error(`Current Wallet does'nt have personalSign method.`);
    }
    this.checkConnected("personalSign");
    return this.RPCMethod.personalSign(message);
  };
  typedSign = (typedData) => {
    if (!this.RPCMethod.typedSign) {
      throw new Error(`Current Wallet does'nt have typedSign method.`);
    }
    this.checkConnected("typedSign");
    return this.RPCMethod.typedSign(typedData);
  };
  addChain = (params, needConnected = true) => {
    if (!this.RPCMethod.addChain) {
      throw new Error(`Current Wallet does'nt have addChain method.`);
    }
    needConnected && this.checkConnected("addChain");
    return this.RPCMethod.addChain(params);
  };
  switchChain = (params) => {
    if (!this.RPCMethod.switchChain) {
      throw new Error(`Current Wallet does'nt have switchChain method.`);
    }
    this.checkConnected("switchChain");
    return this.RPCMethod.switchChain(params);
  };
  watchAsset = (params) => {
    if (!this.RPCMethod.watchAsset) {
      throw new Error(`Current Wallet does'nt have watchAsset method.`);
    }
    this.checkConnected("watchAsset");
    return this.RPCMethod.watchAsset(params);
  };
  requestPermissions = (params) => {
    if (!this.RPCMethod.requestPermissions) {
      throw new Error(`Current Wallet does'nt have requestPermissions method.`);
    }
    return this.RPCMethod.requestPermissions(params);
  };
  requestCrossNetworkPermission = () => {
    if (!this.RPCMethod.requestCrossNetworkPermission) {
      throw new Error(`Current Wallet does'nt have requestCrossNetworkPermission method.`);
    }
    return this.RPCMethod.requestCrossNetworkPermission();
  };
  setCrossNetworkChain = (chainId) => {
    if (typeof chainId !== "string" && chainId !== void 0)
      return;
    this.RPCMethod.crossNetworkChain = chainId;
    this.RPCMethod.getAccounts().then((accounts) => {
      this.RPCMethod.setAccounts(accounts);
      this.handleAccountsChanged(accounts);
    });
  };
};
var emitter_default = Emitter;
export {
  emitter_default as default
};
